// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qT7s","col":"styles_col__16NrA"};